import { createFileRoute } from "@tanstack/react-router";

import ModelAliasesAdmin from "@/components/ModelAliasesAdmin";

// Generated to match `src/app/admin/model-aliases/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/model-aliases")({
  component: ModelAliasesAdmin,
});
